import en from './en.json';
import cn from './cn.json';
import ty from './ty.json';
import vi from './vi.json';
import th from './th.json'

export default {
    en, cn,ty,vi,th
}